import { render, staticRenderFns } from "./increaseInApp.vue?vue&type=template&id=2480d595&scoped=true"
import script from "./increaseInApp.vue?vue&type=script&lang=js"
export * from "./increaseInApp.vue?vue&type=script&lang=js"
import style0 from "./increaseInApp.vue?vue&type=style&index=0&id=2480d595&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2480d595",
  null
  
)

export default component.exports